import React, { FC } from 'react';
import { iconSize } from '../../../../../constants/icon.constants';
import { googleClickAccordionEvent } from '../../../../../utils/analytics';
import Icon from '../../../../@shared/icon';
import { TRowItemProps } from '../../../types/index.types';
import formatText from './formatText';
import SubValueRow from './subValueRow';

const RowItems: FC<TRowItemProps> = (props) => {
  const {
    obj,
    backgroundColor,
    toggleRow,
    index,
    title,
    eyebrow,
    searchTerm,
    colHeadings,
    expandedRows,
    colOrdInIndex,
    showHiddenRightCells,
  } = props;

  return (
    <>
      <tr
        key={`model-detail-specification-table__spec-${obj.group}`}
        className="model-detail-specification-table__spec-category-row"
        style={{ backgroundColor: backgroundColor || '#f4f4f4' }}
        onClick={() => {
          toggleRow(index);
          googleClickAccordionEvent(obj.group, title?.value ?? eyebrow?.value, index + 1);
        }}
      >
        <td
          className="model-detail-specification-table__left-most-cell model-detail-specification-table__spec-category-row-cell"
          colSpan={colHeadings.length + 1}
        >
          <h3
            className={`
                model-detail-specification-table__spec-category-row__inner-box
                ${!expandedRows.includes(index) ? 'model-detail-specification-table__spec-category-row__inner-box--border-visible' : ''}
            `}
          >
            <Icon
              iconName={expandedRows.includes(index) ? 'action-minus' : 'action-plus'}
              size={iconSize.mbl}
              extraClassName={expandedRows.includes(index) ? 'table-minus-icon' : 'table-plus-icon'}
            />

            {formatText(obj.group, searchTerm)}
          </h3>
        </td>
      </tr>
      {obj.items &&
        obj.items.map((subObj, accIndex, subArr) => (                   
            <SubValueRow
              key={subObj.id}
              subObj={subObj}
              subArr={subArr}
              accIndex={accIndex}
              colOrdInIndex={colOrdInIndex}
              hide={!expandedRows.includes(index)}
              showHiddenRightCells={showHiddenRightCells}
              searchTerm={searchTerm}
            />          
        ))}
    </>
  );
};

export default React.memo(RowItems);
